import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import NotifyMeModal from "./NotifyMeModal";

const STORAGE_KEY = "psl_prelaunch_dismissed";

export const PRELAUNCH_MODE =
  String(process.env.REACT_APP_PRELAUNCH_MODE || "false").toLowerCase() === "true";

export default function PreLaunchBanner() {
  const [dismissed, setDismissed] = useState(true);
  const [notifyOpen, setNotifyOpen] = useState(false);

  useEffect(() => {
    if (!PRELAUNCH_MODE) return;
    setDismissed(localStorage.getItem(STORAGE_KEY) === "1");
  }, []);

  if (!PRELAUNCH_MODE) return null;

  const close = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setDismissed(true);
  };

  return (
    <>
      {!dismissed && (
        <div
          data-testid="prelaunch-banner"
          className="relative bg-[#00C3FF] text-[#05050A] text-center px-4 py-2.5 font-mono-tech text-[11px] tracking-[0.18em] uppercase"
        >
          <span>Pre-launch · Checkout opens soon · </span>
          <button
            data-testid="prelaunch-banner-notify"
            onClick={() => setNotifyOpen(true)}
            className="underline underline-offset-2 font-semibold hover:opacity-80"
          >
            Get launch-day discount
          </button>
          <button
            data-testid="prelaunch-banner-close"
            onClick={close}
            className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-black/10 transition-colors"
            aria-label="Dismiss banner"
          >
            <X size={14} />
          </button>
        </div>
      )}
      <NotifyMeModal
        open={notifyOpen}
        onClose={() => setNotifyOpen(false)}
        source="banner"
      />
    </>
  );
}
